export function counterSwiper() {
    const swiperContainer = document.querySelector('.counter-block__inner.swiper');
    
    if (!swiperContainer || typeof Swiper === 'undefined') {
        return;
    }

    const prevButton = swiperContainer.querySelector('.counter-block__arrow--prev');
    const nextButton = swiperContainer.querySelector('.counter-block__arrow--next');

    new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 800,
            effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            1024: {
                effect: 'slide',
                slidesPerView: 3,
                spaceBetween: 60,
            },
            
           
        }
    });
}

